<template>
  <router-view />
</template>

<style lang="less">
@import "./assets/style/reset";
</style>
